<template>
  <v-dialog scrollable v-model="showModalInternal" @input="$event == false ? close() : ''" :max-width="maxWidth">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button v-if="!hideCancelButton" @click="close"></cancel-button>
        <v-btn :color="confirmButtonColor" @click="confirm">{{ confirmButtonLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CancelButton from './CancelButton';
import {LocaleUtils} from '../utils/locale-utils';

export default {
  name: 'ConfirmModal',
  mixins: [
    LocaleUtils,
  ],
  components: {CancelButton},
  props: {
    showModal: null,
    title: null,
    confirmButtonColor: {
      default () {
        return 'primary';
      }
    },
    confirmButtonLabel: {
      default () {
        return this.$t('general.okay');
      }
    },
    maxWidth: {
      default () {
        return 450;
      }
    },
    closeModalOnSelection: {
      default () {
        return true;
      }
    },
    hideCancelButton: {
      type: Boolean,
      default () {
        return false;
      }
    }
  },
  data () {
    return {
      showModalInternal: false
    }
  },
  methods: {
    close() {
      if (this.closeModalOnSelection) {
        this.showModalInternal = false;
      }
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
      this.close();
    }
  },
  watch: {
    showModal (showModal) {
      this.showModalInternal = showModal;
    },
    showModalInternal (showModalInternal) {
      this.$emit('update:show-modal', showModalInternal);
    }
  }
}
</script>
